module.exports = __webpack_public_path__ + "img/0a65f0c.png";